export default __webpack_public_path__ + "static/media/unauthorizedImg.e3158e59.svg";